import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'

@Component({
    selector: 'app-backup',
    templateUrl: './backup.component.html',
    styleUrls: ['./backup.component.css'],
    standalone: false
})
export class BackupComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  tryAgain() {
    this.location.back()
  }

}
